import { defineAsyncComponent } from 'vue'
export default {
  account: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/account.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/empty.vue").then(m => m.default || m)),
  tools: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/tools.vue").then(m => m.default || m)),
  "without-sidebar": defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/without-sidebar.vue").then(m => m.default || m))
}